/*
  Boxxey — minimale ZIP-schrijver (één bestand, methode "stored" = zonder compressie).
  Gebruikt door assets/boxxey-logo-upload.js om PNG/JPG-logo's ongewijzigd te bewaren:
  Shopify's CDN levert afbeeldingen niet byte-identiek, een zip laat het ongemoeid.
  Formaat volgens de ZIP-specificatie (PKWARE APPNOTE): local file header + data +
  central directory + end of central directory. Bestandsnaam als UTF-8 (vlag bit 11).
*/
(function (root) {
  'use strict';

  var CRC_TABLE = (function () {
    var table = new Uint32Array(256);
    for (var n = 0; n < 256; n++) {
      var c = n;
      for (var k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
      table[n] = c >>> 0;
    }
    return table;
  })();

  function crc32(bytes) {
    var crc = 0xffffffff;
    for (var i = 0; i < bytes.length; i++) crc = CRC_TABLE[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
    return (crc ^ 0xffffffff) >>> 0;
  }

  function utf8(text) {
    return new TextEncoder().encode(text);
  }

  function dosDateTime(date) {
    var time = (date.getHours() << 11) | (date.getMinutes() << 5) | Math.floor(date.getSeconds() / 2);
    var day = ((date.getFullYear() - 1980) << 9) | ((date.getMonth() + 1) << 5) | date.getDate();
    return { time: time & 0xffff, date: day & 0xffff };
  }

  // Extra bytes die de zip bovenop het originele bestand toevoegt.
  function overhead(name) {
    var n = utf8(name).length;
    return 30 + n + 46 + n + 22;
  }

  // Geeft de onderdelen terug (voor new Blob(parts)); het originele bestand wordt niet gekopieerd.
  function storedZipParts(name, bytes, date) {
    var nameBytes = utf8(name);
    var crc = crc32(bytes);
    var size = bytes.length;
    var dt = dosDateTime(date || new Date());

    var local = new DataView(new ArrayBuffer(30));
    local.setUint32(0, 0x04034b50, true); // local file header
    local.setUint16(4, 20, true); // versie nodig: 2.0
    local.setUint16(6, 0x0800, true); // vlag: UTF-8 bestandsnaam
    local.setUint16(8, 0, true); // methode 0 = stored
    local.setUint16(10, dt.time, true);
    local.setUint16(12, dt.date, true);
    local.setUint32(14, crc, true);
    local.setUint32(18, size, true); // gecomprimeerd = origineel
    local.setUint32(22, size, true);
    local.setUint16(26, nameBytes.length, true);
    local.setUint16(28, 0, true);

    var central = new DataView(new ArrayBuffer(46));
    central.setUint32(0, 0x02014b50, true); // central directory header
    central.setUint16(4, 20, true); // gemaakt met versie 2.0
    central.setUint16(6, 20, true);
    central.setUint16(8, 0x0800, true);
    central.setUint16(10, 0, true);
    central.setUint16(12, dt.time, true);
    central.setUint16(14, dt.date, true);
    central.setUint32(16, crc, true);
    central.setUint32(20, size, true);
    central.setUint32(24, size, true);
    central.setUint16(28, nameBytes.length, true);
    // extra, commentaar, schijf, interne/externe attributen: 0
    central.setUint32(42, 0, true); // offset van de local header

    var centralSize = 46 + nameBytes.length;
    var centralOffset = 30 + nameBytes.length + size;
    var end = new DataView(new ArrayBuffer(22));
    end.setUint32(0, 0x06054b50, true); // end of central directory
    end.setUint16(8, 1, true); // 1 bestand op deze schijf
    end.setUint16(10, 1, true); // 1 bestand totaal
    end.setUint32(12, centralSize, true);
    end.setUint32(16, centralOffset, true);

    return [new Uint8Array(local.buffer), nameBytes, bytes, new Uint8Array(central.buffer), nameBytes, new Uint8Array(end.buffer)];
  }

  root.BoxxeyZip = { crc32: crc32, overhead: overhead, storedZipParts: storedZipParts };
})(typeof window !== 'undefined' ? window : globalThis);
